import { render } from "./SingleFormSubmission.vue?vue&type=template&id=0e36c0e6"
import script from "./SingleFormSubmission.vue?vue&type=script&lang=js"
export * from "./SingleFormSubmission.vue?vue&type=script&lang=js"

import "./SingleFormSubmission.vue?vue&type=style&index=0&id=0e36c0e6&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__